export default __webpack_public_path__ + "static/media/logo copy.602048df.png";